export class XYoutube extends HTMLElement {
    static componentName: string = "x-youtube";
  
    constructor() {
      super();
    }
  
    connectedCallback() {
        const videoId = this.getAttribute("video-id");
        const thumbnailImage = this.getAttribute("video-thumbnail");

        if (!videoId || !thumbnailImage) {
          console.log("Missing video-id or video-thumbnail attributes");
          return;
        }
      
      this.innerHTML = `
      <div class="video-container" style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; background: #000; cursor: pointer;">
          <img class="video-thumbnail" src="${thumbnailImage}" alt="Video Thumbnail" width="600" height="337.5" style="display: block; width: 100%; height: auto;" />
          <div class="play-button" style="position: absolute; width: 68px; height: 48px; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 50px; color: white;">
<svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg>          </div>
          </div>
      `;
  
      const container = this.querySelector('.video-container');
  
      container.addEventListener('click', () => {
        this.loadVideo(videoId);
      });
  
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadVideo(videoId);
            observer.disconnect(); 
          }
        });
      });
  
      observer.observe(container);
    }
  
    loadVideo(videoId) {
      if (!videoId) return;
  
      // const autoplayUrl = `${videoId}&autoplay=1`;
  
      this.innerHTML = `
        <div class="video-container" style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; background: #000;">
        <iframe width="100%" height="100%" style="position: absolute; top: 0; left: 0;" 
                src="${videoId}" 
                frameborder="0"  encrypted-media">
        </iframe>
      </div>
      `;
    }
  }
  
  if (!customElements.get(XYoutube.componentName)) {
    customElements.define(XYoutube.componentName, XYoutube);
  }
  